module.exports = __webpack_public_path__ + "assets/img/chihuang50_4.bb67fe14.jpg";